/**
 * 把 shared 的 BlockReason 翻成给孩子看的话
 *
 * 原则：**说清"为什么不行"和"怎样才能行"**。
 * 一个点了没反应的按钮会让孩子以为游戏坏了 —— 这比难度本身更劝退。
 * 文案避免责备语气（「你不够聪明」这种话永远不出现）。
 */

import type { BlockReason } from "@chuandeng/shared";

const REASON_TEXT: Record<BlockReason, string> = {
  // 路线
  route_unknown: "这里还没有路",
  route_not_revealed: "还看不见这条路，先点亮「疫病地图」",
  route_closed: "商路暂时断绝，下一回合会恢复",
  route_need_card: "先答对相关的题目，拿到那张知识卡",
  source_not_ignited: "起点还没有火种营地",
  region_full: "这里已经一片通明",
  insufficient_energy: "火种能量不够了，结束回合可以恢复",
  // 点燃
  region_unknown: "这里还不是我们的地方",
  already_ignited: "这里已经有营地了",
  not_adjacent: "要挨着已有火种的地方才能扎营",
  // 技能树
  node_unknown: "还没有这个知识",
  node_already_unlocked: "已经学会了",
  node_need_parent: "先学会它前面的那个知识",
  insufficient_wisdom: "智慧值还不够，答对题目可以增加",
};

export function reasonText(reason: BlockReason | undefined): string {
  if (!reason) return "";
  return REASON_TEXT[reason] ?? "暂时还不行";
}

/** 是否属于"资源不足"类（UI 上强调"结束回合/答题"这两条出路） */
export function isResourceReason(reason: BlockReason | undefined): boolean {
  return reason === "insufficient_energy" || reason === "insufficient_wisdom";
}
